import { Button, Progress } from 'antd';
import Link from 'next/link';
import { useEffect, useState } from 'react';
import useSwr from 'swr';
import styles from './StorageLimit.module.css';

export default function StorageLimitWidget() {
   const userStorage = useSwr('/api/user/storage');
   const currentUser = useSwr('/api/user/current');
   const [percent, setPercent] = useState(0);

   useEffect(() => {
      if (userStorage.data) {
         setPercent(((userStorage.data.totalStorageUsed / userStorage.data.availableStorage) * 100).toFixed(0));
      }
   }, [userStorage.data]);

   function getSizeWithUnit(size) {
      const units = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
      let unitIndex = 0;
      while (size > 1000) {
         size /= 1000;
         unitIndex++;
      }
      return `${size.toFixed(0)} ${units[unitIndex]}`;
   }

   return (
      <>
         <div className={styles.storageLimit}>
            <p className={styles.storageLimitTitle}>Storage Limit</p>
            <Progress
               // percent={((userStorage.data.totalStorageUsed / userStorage.data.availableStorage) * 100).toFixed(0)}
               percent={percent}
               {...(percent < 100 && { status: 'active' })}
               {...(percent > 50 && { strokeColor: { '0%': '#108ee9', '100%': '#5015F6' } })}
               {...(percent > 90 && { strokeColor: { '0%': '#108ee9', '50%': '#5015F6', '100%': '#E01E6D' } })}
               showInfo={false}
               size="small"
            />
            <div className={styles.storageLimitText}>
               <span>{userStorage.data ? getSizeWithUnit(userStorage.data.totalStorageUsed) : 0}</span>
               <span>{userStorage.data ? getSizeWithUnit(userStorage.data.availableStorage) : 0}</span>
            </div>
            <div className={styles.callToAction}>
               {!currentUser?.data?.isPremium && (
                  <Link href="/upgrade" target="_blank">
                     <Button type="primary" size="small" block>
                        Upgrade
                     </Button>
                  </Link>
               )}
            </div>
         </div>
      </>
   );
}

// '0%': '#108ee9',
// '50%': '#5015F6',
// '100%': '#E01E6D',
